import styled from 'styled-components'
import { MdSearch } from 'react-icons/md'

import {
  gray,
  darkGray,
  lightGray,
  lightSalmon,
} from '../../styles/themeColors'

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`

export const SearchInput = styled.input`
  background-color: #ffffff;
  border: 1px solid ${lightGray};
  border-radius: 4px;
  color: ${darkGray};
  font-size: 14px;
  height: 40px;
  outline: none;
  padding-left: 12px;
  padding-right: 40px;
  width: 100%;

  &:focus {
    border-color: ${gray};
  }

  &::placeholder {
    color: ${gray};
  }
`

export const SearchIcon = styled(MdSearch)`
  color: ${gray};
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
`

export const ResultsList = styled.div`
  background-color: #ffffff;
  border: 1px solid ${lightGray};
  border-radius: 4px;
  border-top: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 10;

  .result-item {
    background: none;
    border: none;
    border-bottom: 1px solid ${lightGray};
    color: inherit;
    cursor: pointer;
    font: inherit;
    padding: 12px;
    text-align: left;
    transition: background-color 0.2s ease;
    width: 100%;

    &:hover {
      background-color: ${lightSalmon};
    }

    &:focus {
      background-color: ${lightSalmon};
      outline: none;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .no-results {
    color: ${gray};
    font-style: italic;
    padding: 12px;
    text-align: center;
  }
`
